import { render, staticRenderFns } from "./BookletPartsList.vue?vue&type=template&id=e56c9978&scoped=true"
import script from "./BookletPartsList.vue?vue&type=script&lang=js"
export * from "./BookletPartsList.vue?vue&type=script&lang=js"
import style0 from "./BookletPartsList.vue?vue&type=style&index=0&id=e56c9978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56c9978",
  null
  
)

export default component.exports